<p-tree
  [value]="data$ | async"
  [filter]="true"
  selectionMode="single"
  filterPlaceholder="Filter Presets"
  [contextMenu]="contextMenu"
  (onNodeSelect)="onNodeSelect($event)"
  [(selection)]="selectedPreset"

/>
<p-contextMenu #contextMenu [model]="contextItems"/>

